import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <div className="bg-gradient-to-r from-blue-900 to-blue-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Use</h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Rules and guidelines for using RDS Group of Colleges website and services
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8">
          <div className="border-b border-gray-200 pb-4 flex justify-between items-center">
            <p className="text-gray-600">Last Updated: March 17, 2026</p>
            <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-xs font-semibold">Effective</span>
          </div>
          <div className="bg-orange-50 p-6 rounded-xl">
            <p className="text-gray-700 leading-relaxed">
              Welcome to RDS Group of Colleges. By accessing our website, you agree to be bound by these Terms of Use. Please read them carefully. If you do not agree with any part of these terms, you may not use our website or services.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              These Terms of Use constitute a legally binding agreement between you and RDS Group of Colleges governing your use of our website, services, and facilities. By using our website, you acknowledge that you have read, understood, and agree to be bound by these terms.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              2. Use of Website
            </h2>
            <div className="pl-6 space-y-3">
              <p className="text-gray-700 leading-relaxed">You agree to use our website only for lawful purposes and in a way that does not infringe the rights of others or restrict their use of the website. Prohibited activities include:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Violating any applicable laws or regulations</li>
                <li>Impersonating any person or entity</li>
                <li>Interfering with the security or functionality of the website</li>
                <li>Uploading or transmitting viruses or malicious code</li>
                <li>Collecting or storing personal data about other users</li>
              </ul>
            </div>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              3. Intellectual Property
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              All content on this website, including text, graphics, logos, images, and software, is the property of RDS Group of Colleges or its content suppliers and is protected by Indian and international copyright laws. You may not reproduce, distribute, modify, or create derivative works without our prior written consent.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              4. Admissions and Enrollment
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              Admission to RDS Group of Colleges is subject to meeting the eligibility criteria and completion of the admission process. We reserve the right to reject any application without assigning any reason. Fees once paid are non-refundable except as explicitly stated in the refund policy.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              5. User Accounts
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              If you create an account on our website, you are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              6. Third-Party Links
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              Our website may contain links to third-party websites. We are not responsible for the content, privacy policies, or practices of these websites. Accessing third-party links is at your own risk.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              7. Disclaimer of Warranties
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              Our website and services are provided "as is" without any warranties, express or implied. We do not guarantee that the website will be uninterrupted, error-free, or free of viruses or other harmful components.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              8. Limitation of Liability
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              To the maximum extent permitted by law, RDS Group of Colleges shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of our website or services.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              9. Governing Law
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              These Terms of Use shall be governed by and construed in accordance with the laws of India. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in Jaunpur, Uttar Pradesh.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              10. Changes to Terms
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting on this page. Your continued use of the website after changes constitutes acceptance of the revised terms.
            </p>
          </div>
          <div className="mt-8 bg-gradient-to-r from-orange-50 to-blue-50 p-6 rounded-xl border border-orange-200">
            <h3 className="text-xl font-bold text-blue-800 mb-4 flex items-center">
              <svg className="w-5 h-5 text-orange-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              Contact Us Regarding Terms
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600">Email</p>
                <a href="mailto:rdscollege342@gmail.com" className="text-blue-800 hover:text-orange-600 font-medium">rdscollege342@gmail.com</a>
              </div>
              <div>
                <p className="text-sm text-gray-600">Phone</p>
                <p className="text-blue-800 font-medium">7275370808, 9628362187</p>
              </div>
              <div className="md:col-span-2">
                <p className="text-sm text-gray-600">Address</p>
                <p className="text-blue-800 font-medium">Kusanw Bhaupur, Jaunpur, UP-222136</p>
              </div>
            </div>
          </div>
          <div className="text-center text-sm text-gray-500 pt-4 border-t border-gray-200">
            <p>© 2026 RDS Group of Colleges. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;